import { axios } from 'api'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import CoachHeader from './CoachHeader'
import { useParams } from 'react-router-dom'
import CoachBio from './CoachBio'
import InstructorPage from 'components_v1/pageLevelComponents/instructor/InstructorPage'
import { flattenMeta, useMeta, useTitle } from 'hooks/useMetaTitle'
import { CURRENT_URL, useCommonEntryContext } from 'components_v2/common'
const getDesc = (text = '') => text.split(' ').slice(0, 170).join(' ')

const Main = styled.div`
  .profile-bio p {
    margin-bottom: 5px;
  }
`
const InstructorView = () => {
  const { id } = useParams()
  const [coach_info, setCoachInfo] = useState(null)
  const [props, setProps] = useState()
  const { user, setNotFound } = useCommonEntryContext()

  useEffect(() => {
    setCoachInfo(null)
    setProps(null)
    axios
      .get(`/coaches/${id}`, { load: true })
      .then((res) => {
        const info = res.data?.coachInfo
        setCoachInfo(info)
        setProps(res.data?.pageData)
        window.dataLayer ||= []
        window.dataLayer.push({
          event: 'instructor_page_view',
          instructor: info?.name
        })
      })
      .catch((err) => {
        setNotFound(true)
        console.log(err)
      })
  }, [id, setNotFound])

  useTitle(coach_info?.name)

  useMeta([
    {
      name: 'description',
      content: props?.tagLine || getDesc(coach_info?.bio)
    },
    {
      name: 'keywords',
      content: props?.keywords?.join(', ')?.toLowerCase()
    },
    ...flattenMeta({
      og: {
        title: coach_info?.name,
        type: 'website',
        description: coach_info?.tagLine || getDesc(coach_info?.bio),
        url: CURRENT_URL,
        image: [
          {
            _: coach_info?.photoUrl,
            width: 320,
            height: 180
          }
        ]
      }
    })
  ])

  if (!coach_info || !props) return null
  return (
    <Main className='coach-container'>
      <div className='profile'>
        <CoachHeader coachInfo={coach_info} />
        <CoachBio coachInfo={coach_info} />
        <hr className='section-divider'></hr>
      </div>
      <div className='all-sections-container'>
        <div className='section-container coach-classes class-scroll-to'>
          <div className='new-explore explore-cold-start'>
            <div className='single-class-container'>
              <InstructorPage
                autopaginate={false}
                disableStickyFilter={true}
                defaultOrder='date'
                defaultValue={true}
                pageVersion='filter'
                currentUser={user}
                baseUrl={`/instructors/${coach_info?.slug}`}
                filteredInstructors={coach_info?.slug || ''}
                {...props}
              />
            </div>
          </div>
        </div>
      </div>
    </Main>
  )
}

export default InstructorView
